import React from 'react';
import './style.scss';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';
import { IssuanceDocumentFolderInfo } from 'views/utils/graphql/graphql';

export type DocumentFolderProps = {
  folder: IssuanceDocumentFolderInfo;
  onFolderSelect: (folder: IssuanceDocumentFolderInfo) => void;
};

const icon = findIcon(IconName.folder);

export const DocumentFolder: React.FC<DocumentFolderProps> = ({ folder, onFolderSelect }: DocumentFolderProps) => {
  return (
    <div className="documentDirectory" onClick={() => onFolderSelect(folder)}>
      <div className="documentDirectory_icon">
        <SvgIcon icon={icon} size={IconSize.icon_m} />
      </div>
      <div className="documentDirectory_label">{folder.Name}</div>
    </div>
  );
};
